module.exports = __webpack_public_path__ + "components/flag/static/square/cz-742eb113c7a7e2aa66f670e479328872.svg";